import {Tooltip} from '@hm/fundamental'

interface ColorButtonProps {
  color: string
  isSelected?: boolean
  isDisabled?: boolean
  onClick?: () => void
  dataCy?: string
}

export const ColorButton: React.FC<ColorButtonProps> = ({
  color,
  isSelected = false,
  isDisabled = false,
  onClick,
  dataCy
}) => {
  return (
    <Tooltip content={color}>
      <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        className={`
          w-8 h-8 rounded border-2 cursor-pointer transition-all
          hover:scale-110 hover:shadow-md
          disabled:opacity-50 disabled:cursor-default disabled:hover:scale-100 disabled:hover:shadow-none
          ${isSelected ? 'border-primary ring-2 ring-primary ring-offset-1' : 'border-border'}
        `}
        style={{backgroundColor: color}}
        data-cy={dataCy}
      />
    </Tooltip>
  )
}
